import React, { useState, useEffect, useRef } from "react"
import 'react-perfect-scrollbar/dist/css/styles.css';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@material-ui/core';
import { ThemeProvider } from "styled-components"
import GlobalStyles from './components/GlobalStyles';
import theme from './theme';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';

import Home from './pages/Home';
import WithScale from './pages/WithScale';
import Dashboard from './pages/Dashboard';


function GoToHome({ children }: { children: JSX.Element }) {
  let location = useLocation();
  return <Navigate to="/" state={{ from: location }} />;
}


const App = () => {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <Routes>

            <Route exact path="/" element={
              <Home/>
            }/>

            <Route exact path="/dashboard" element={
              <Dashboard/>
            }/>

            <Route exact path="/withScale" element={
              <WithScale/>
            }/>

            <Route exact path='*' element={
              <GoToHome/>
            }/>

          </Routes>
        </ThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
